import '@webcomponents/shadycss/entrypoints/apply-shim.js';

const styleElement = document.createElement('dom-module');
styleElement.innerHTML =
`<template>
<style>
  :host {
    display: block;
    height: 100%;
    @apply --type-base;
    --com-calendar-date-transform-translate: 55%;
    --com-calendar-date-move-animation-duration: .45s;
    --com-calendar-date-cloneMove-animation-duration: .45s;
    --com-calendar-date-move-opacity: 1;

    /*THIS IS JUST FOR TEST THE HOVER STATE*/
    --com-calendar-date-hover-color: #fff;
    --com-calendar-date-hover-number-color: #fff;
    --com-calendar-date-hover-border-width: 0;
    --com-calendar-date-hover-background: #fff;
    --com-calendar-date-active-background: #fff;

    --com-frame-clean: {
      border: none;
      border-radius: none;
      padding: inherit;
    }
  }

  :host([enable-track]) .clone {
    top: 48px;
    left: 10px;
    width: 95%;
  }

  /* clean presentation with no borders around dates */
  :host([clean]) {
    --com-calendar-date-disabled-border: white;
    --com-calendar-date-past-border: white;
    --com-calendar-date-active-border: white;
    --com-calendar-date-action-border: white;
    --com-calendar-date-hover-border: white;
  }

  :host([clean]) .weekdaysHeader {
    border-bottom: var(--com-weekday-clean-bottom-border-width, 1px) solid var(--com-calendar-date-disabled-color, #ACBAC1);
  }

  :host([clean]) .weekdays {
    margin-bottom: 10px;
  }

  :host([enable-swipeable-header]) .calendarNav {
    @apply --com-calendar-date-calendarNav-styles;
  }

  .calendarNav,
  .calendarHeaderSwipe {
    @apply --layout;
    color: var(--com-calendar-date-header-color, --primary-active);
  }

  .calendarNav {
    @apply --layout-center-justified;
    @apply --type20;
    margin-bottom: 14px;
  }

  :host([use-grid-display-style]) .calendarNav {
    @apply --type18;
    margin-bottom: 8px;
  }

  .calendarNavBtn {
    @apply --com-calendar-date-nav-btn-styles;
  }

  :host .calendarNav {
    @apply --type18;
    justify-content: space-between;
    margin-bottom: 14px;
    @apply --com-calendar-date-nav-mobile-styles;
  }

  :host([use-grid-display-style]) .calendarNav {
    justify-content: center;
  }

  :host([navigation="swipe-and-tap"]) .calendarNav {
    position: absolute;
    width: 100%;
    z-index: 1;
    margin-bottom: 16px;
  }

  :host([navigation="none"]) .calendarNav {
    justify-content: center;
  }

  :host #prevArrow,
  :host #nextArrow {
    margin: var(--com-calendar-date-compact-nav-arrow-styles, 0);
    padding: 1px 5px;
    @apply --type18;
  }

  /* class is used when multiple months are shown (navigation=swipe) */
  .monthHeader,
  .monthHeader {
    @apply --heavy;
    width: 20%;
  }
  .monthYearHeader {
    text-align: center;
    white-space: nowrap;
    margin: auto;
    @apply --user-select-none;
    @apply --com-calendar-date-monthYearHeader-style;
    @apply --roman;
  }

  .weekdaysHeader {
    @apply --layout;
    @apply --user-select-none;
  }

  /* when swiping, year/month text will go under the arrows */
  :host([navigation="swipe-and-tap"]) #prevArrow,
  :host([navigation="swipe-and-tap"]) #nextArrow {
    background-color: white;
    @apply --type20;
    font-weight: 400;
  }

  #nextArrow {
    text-align: right;
  }

  :host([enable-track]) .monthWrapper {
    height: auto;
  }

  .monthWrapper {
    position: relative;
    height: 100%;
  }

  .navMonthYear:focus,
  .month:focus {
    @apply --focus;
  }

  .month {
    @apply --layout;
    @apply --layout-wrap;
    margin: 1px 0px 1px 1px;
  }

  .day {
    /*
    * plus 1px is because of the negative margin
    * note: 0.96 is used instead of one for IE11/Edge compatibility;
    */
    width: calc((100%/7) + 0.96px);
    margin: 1px 0 0 -1px;
    height: 86px;
    border-bottom: 1px solid var(--com-calendar-date-disabled-color, #ACBAC1);
    position: relative;
    color: var(--com-calendar-date-disabled-color, #ACBAC1);
  }

  .day.lastRow {
    border-bottom: none;
  }

  .day.lastWeekday,
  .day.firstWeekday {
    position: relative;
  }

  .day .blank.highlight.firstWeekday,
  .day .blank.highlight.lastWeekday,
  .day.firstWeekday ::slotted(com-calendar-date),
  .day.lastWeekday ::slotted(com-calendar-date) {
    width: calc(100% + var(--com-calendar-date-container-padding, 14px));
    position: absolute;
  }

  :host(:not([use-grid-display-style])) .day .blank.highlight.firstWeekday,
  :host(:not([use-grid-display-style])) .day.firstWeekday ::slotted(com-calendar-date) {
    left: -14px;
    --com-calendar-date-container-padding-left: 14px;
    --com-calendar-date-indicator-padding-left: 14px;
  }

  :host-context([disable-weekdays-border]) .day {
    border-bottom: none;
  }

  :host(:not([use-grid-display-style])) .day.lastWeekday ::slotted(com-calendar-date) {
    --com-calendar-date-container-padding-right: 14px;
    --com-calendar-date-indicator-padding-right: 14px;
  }

  .blank {
    box-sizing: border-box;
  }

  .blank.highlight {
    display: flex;
    flex-direction: column;
    padding-top: var(--com-calendar-fuse-padding-top, 3px);
  }

  .blank.highlight .dayPlaceholder {
    height: var(--com-calendar-fuse-height, 43px);
    width: 100%;
    border-top: 1px solid var(--inactive-grey);
    border-bottom: 1px solid var(--inactive-grey);
    background-color:var(--background-component);
  }

  /* swipe navigation */
  :host([navigation="swipe"]),
  :host([navigation="swipe-and-tap"]) {
    overflow: hidden;
    position: relative;
    box-sizing: border-box;
  }

  :host([navigation="swipe"]) #months,
  :host([navigation="swipe-and-tap"]) #months {
    position: relative;
    width: 10000px;
    box-sizing: border-box;
    @apply --layout;
  }

  :host([navigation="swipe"]) #months.hide,
  :host([navigation="swipe-and-tap"]) #months.hide {
    display: none;
  }

  :host([navigation="swipe"]) .monthWrapper,
  :host([navigation="swipe-and-tap"]) .monthWrapper {
    margin: 0 3.5px;
  }

  :host([navigation="swipe"]) .monthWrapper:not([visible]),
  :host([navigation="swipe-and-tap"]) .monthWrapper:not([visible]) {
    visibility: hidden;
  }

  :host([navigation="swipe"]) .monthWrapper:not([active]),
  :host([navigation="swipe-and-tap"]) .monthWrapper:not([active]) {
    pointer-events: none;
  }

  /* without navigation arrows, the text aligns to the left */
  .calendarHeaderSwipe {
    @apply --layout-start-justified;
    @apply --type18;
    justify-content: center;
    margin-bottom: 14px;
    @apply --com-calendar-date-header-swipe-styles;
  }

  :host([navigation="swipe-and-tap"]) .calendarHeaderSwipe {
    @apply --type20;
    justify-content: center;
    align-items: center;
    height: 28px;
    margin-bottom: 19px;
  }

  .calendarHeaderSwipe .monthYearHeader {
    text-align: left;
    @apply --com-calendar-date-monthYearHeader-style;
  }

  /* compact view updates the weekday header & dates */
  :host .weekdaysAndMonth {
    border: 1px solid var(--com-calendar-date-border-color, --inactive-grey);
    border-radius: 3px;
    box-sizing: border-box;
    padding: var(--com-calendar-date-container-padding-left, 14px);
    padding-bottom: 7px;
    background-color: white;
    height: 100%;
  }

  :host([use-grid-display-style]) .weekdaysAndMonth {
    padding: 0 var(--com-calendar-date-container-padding-left, 14px);
  }

  :host #months {
    transition: .06s ease-in;
    transform: translateZ(0);
    border: 1px solid var(--inactive-grey);
    border-radius: 5px;
  }

  :host([use-grid-display-style]) #months {
    border-radius: 0;
  }

  :host([enable-track]) #months {
    transition: .5s ease-in-out;
  }

  :host([navigation="swipe-and-tap"]) #months {
    height: calc(100% - 47px);
  }

  :host([enable-track]) .month,
  :host([enable-track]) .day {
    will-change: transform, opacity;
  }

  :host .weekdays {
    width: calc(100%/7);
    box-sizing: border-box;
    @apply --type16;
    text-align: center;
    @apply --com-calendar-date-weekdays-style;
    color: var(--com-calendar-date-weekdays-color, var(--message-grey, #78899E));
  }

  :host([use-grid-display-style]) .weekdays {
    @apply --type12;
    margin-bottom: 5px;
  }

  :host .weekdaysHeader {
    margin: 7px 0 0 0;
    height: auto;
  }

  :host .day {
    height: var(--com-calendar-date-height, 50px);
  }

  :host .month {
    @apply --no-highlight-selection;
  }

  :host .monthWrapper:not([active]) .month {
    max-height: calc(4 * var(--com-calendar-date-height, 50px));
  }

  @keyframes com-calendar-moveLeft {
    0% {
      opacity: 0;
    }
    25% {
      opacity: 0;
    }
    50% {
      opacity: 0;
      transform: translate(var(--com-calendar-date-transform-translate));
    }
    75% {
      opacity: .5;
    }
    100% {
      opacity: 1;
    }
  }

  .moveLeft {
    visibility: visible;
    animation: com-calendar-moveLeft var(--com-calendar-date-move-animation-duration) ease-in-out;
  }

  @keyframes com-calendar-cloneMoveLeft {
    0% {
      opacity: var(--com-calendar-date-move-opacity);
      border: 0;
    }
    50% {
      opacity: .25;
      transform: translate(calc(-1 * var(--com-calendar-date-transform-translate)));
    }
    100% {
      opacity: 0;
    }
  }

  .cloneMoveLeft {
    visibility: visible;
    animation: com-calendar-cloneMoveLeft var(--com-calendar-date-cloneMove-animation-duration) ease-in-out;
  }

  @keyframes com-calendar-moveRight {
    0% {
      opacity: 0;
    }
    25% {
      opacity: 0;
    }
    50% {
      opacity: 0;
      transform: translate(calc(-1 * var(--com-calendar-date-transform-translate)));
    }
    75% {
      opacity: .5;
    }
    100% {
      opacity: 1;
    }
  }

  .moveRight {
    visibility: visible;
    animation: com-calendar-moveRight var(--com-calendar-date-move-animation-duration) ease-in-out;
  }

  @keyframes com-calendar-cloneMoveRight {
    0% {
      opacity: var(--com-calendar-date-move-opacity);
      border: 0;
    }
    50% {
      opacity: .25;
      transform: translate(var(--com-calendar-date-transform-translate));
    }
    100% {
      opacity: 0;
    }
  }

  .cloneMoveRight {
    visibility: visible;
    animation: com-calendar-cloneMoveRight var(--com-calendar-date-cloneMove-animation-duration) ease-in-out;
  }

  :host([enable-track]) .clone {
    top: 48px;
    left: 10px;
    width: 95%;
  }

  :host([enable-swipeable-header]) .clone {
    top: 87px;
  }

  .clone {
    position: absolute;
    top: 25px;
    width: 100%;
    z-index: 20;
  }

  #endMessage {
    height: 450px;
    width: 100%;
    box-sizing: border-box;
  }

  :host #endMessage {
    margin-top: 0;
    height: 282px;
  }

  /* Drawer Animation Styling Begin */

  @keyframes com-calendar-drawer-move-down {
    0% {
      transform: translateY(-25%);
    }
  }

  @keyframes com-calendar-drawer-move-up {
    0% {
      transform: translateY(25%);
    }
  }

  :host([navigation="swipe"]) .drawer-move-down,
  :host([navigation="swipe-and-tap"]) .drawer-move-down {
    visibility: visible;
    animation: com-calendar-drawer-move-down .2s ease;
  }

  :host([navigation="swipe"]) .drawer-move-up,
  :host([navigation="swipe-and-tap"]) .drawer-move-up {
    visibility: visible;
    animation: com-calendar-drawer-move-up .2s ease;
  }

  :host([navigation="tap"]) .drawer-move-down,
  :host([navigation="swipe-and-tap"]) .drawer-move-down {
    visibility: visible;
    animation: com-calendar-drawer-move-down .4s ease;
  }

  :host([navigation="tap"]) .drawer-move-up,
  :host([navigation="swipe-and-tap"]) .drawer-move-up {
    visibility: visible;
    animation: com-calendar-drawer-move-up .4s ease;
  }

  :host([navigation="swipe"]) #drawer,
  :host([navigation="swipe-and-tap"]) #drawer {
    width: calc(100% - 40px);
    margin-left: auto;
    margin-right: auto;
  }

  :host([navigation="swipe"]) #drawer.drawer-up,
  :host([navigation="swipe-and-tap"]) #drawer.drawer-up {
    margin-top: calc(-1 * var(--com-calendar-date-height, 50px)); /* height of one row */
  }

  /*for desktop animation */
  #drawer {
    position: relative;
    z-index: 100;
  }

  #drawer:focus {
    outline: none;
  }
</style>
</template>`;

styleElement.register('com-calendar-base-style');